import React, { CSSProperties } from 'react';
import './MetricsDisplay.css'

export interface ChemBioThreatDisplayProps { title: String | null, value: String | Object | null, units: String | null, style?: CSSProperties | undefined, threatStyle?: CSSProperties | undefined}
export interface ChemBioThreatDisplayState { }

export class ChemBioThreatDisplay extends React.Component<ChemBioThreatDisplayProps> {
    render() {
        var body;
        if (typeof (this.props.value) === 'object') {
            body = this.props.value;
        } else {
            body =
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                    <label className="metric" style={this.props.threatStyle}>{this.props.value}</label>
                    <label className="units">{this.props.units}</label>
                </div>
        }
        return (
            <div className="inv-metric-container" style={this.props.style}>
                <label className="metric-title">{this.props.title}</label>
                {body}
            </div>
        )
    }
}

export default ChemBioThreatDisplay
